// src/pages/msp-inventory/components/reports/TableControls.jsx
import React from "react";
import { ChevronLeft, ChevronRight, ChevronUp, ChevronDown } from "lucide-react";

export const SortableTH = ({ label, sortKey, sortConfig, onSort, className = "" }) => {
    const active = sortConfig.key === sortKey;
    return (
        <th
            onClick={() => onSort(sortKey)}
            className={`pb-2 font-semibold cursor-pointer select-none hover:text-teal-600 transition whitespace-nowrap ${className}`}
        >
            <span className="inline-flex items-center gap-1">
                {label}
                {active && (sortConfig.dir === "asc" ? <ChevronUp size={11} /> : <ChevronDown size={11} />)}
            </span>
        </th>
    );
};

export const Pagination = ({ page, totalPages, setPage, totalItems, pageSize }) => {
    if (totalItems === 0) return null;
    const startItem = (page - 1) * pageSize + 1;
    const endItem = Math.min(page * pageSize, totalItems);
    return (
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100 text-xs text-gray-500">
            <span>Showing {startItem}-{endItem} of {totalItems}</span>
            <div className="flex items-center gap-2">
                <button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}
                    className="px-3 py-1.5 border border-gray-200 rounded-lg disabled:opacity-30 flex items-center gap-1 hover:border-teal-400 transition">
                    <ChevronLeft size={12} /> Prev
                </button>
                <span className="font-semibold text-gray-600">Page {page} of {totalPages}</span>
                <button onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages}
                    className="px-3 py-1.5 border border-gray-200 rounded-lg disabled:opacity-30 flex items-center gap-1 hover:border-teal-400 transition">
                    Next <ChevronRight size={12} />
                </button>
            </div>
        </div>
    );
};